// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBVDS_qf6mprjIoqh6ZI-zKZvHLcQeUI6g",
  authDomain: "validados-ven-prod.firebaseapp.com",
  projectId: "validados-ven-prod",
  storageBucket: "validados-ven-prod.appspot.com",
  messagingSenderId: "565720914522",
  appId: "1:565720914522:web:e467f24a6d683f71b6d663",
  measurementId: "G-VQ4GEY72ZX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);